import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import parsePhoneNumberFromString from 'libphonenumber-js/max';

export class PhoneValidators {
    static isValidPhoneNumber: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
        const countryCode = group.get('countryCode')?.value?.value || '';
        const number = group.get('number')?.value || '';

        if (countryCode && number) {
            const combinedNumber = `${countryCode}${number}`;

            const processedTelephoneNumber = parsePhoneNumberFromString(combinedNumber);

            return processedTelephoneNumber?.isValid() || group.untouched ? null : { invalidPhoneNumber: true };
        } else if (!countryCode && !number && group.dirty) {
            return { missingRequiredInfo: true };
        } else {
            return null;
        }
    };

    static isValidCode: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const countryCode = control.value?.value || '';

        return !countryCode && control.touched
            ? { invalidCountryCode: { message: $localize`The country code is missing.` } }
            : null;
    };

    static isValidNumber: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const number = control.value || '';

        return !number && control.touched
            ? { missingPhoneNumber: { message: $localize`The mobile number is missing.` } }
            : null;
    };
}
